import { useMemo } from 'react';

import { selectProfessions } from 'store/autoReducers';
import { selectPredictedProfRoles } from 'store/models/predictWindow';
import { useSelector } from 'store/utils';

interface ComputedProfRole {
    id: string;
    name: string;
}

export const useComputePredictedProfRoles = (): ComputedProfRole[] | [] => {
    const professions = useSelector((state) => selectProfessions(state));
    const predictedProfRoles = useSelector(selectPredictedProfRoles);

    return useMemo(() => {
        if (!predictedProfRoles?.length || !professions?.length) return [];

        const predictedProfRolesCopy = new Set(predictedProfRoles);
        const result = [] as ComputedProfRole[];

        professions.some((professionCategory) => {
            professionCategory.professionalRoles?.some(({ id, name }) => {
                const stringId = id.toString();

                if (predictedProfRolesCopy.has(stringId)) {
                    predictedProfRolesCopy.delete(stringId);

                    // ищем начальный индекс проф. роли, чтобы результат имел ту же сортировку, какую прислали с БЕ
                    let professionIndex = predictedProfRoles.findIndex((predictedId) => predictedId === stringId);
                    // если не находим (в теории это невозможно), то кладём в конец результата
                    professionIndex = professionIndex === -1 ? result.length : professionIndex;

                    result[professionIndex] = { id: stringId, name };
                }

                return !predictedProfRolesCopy.size;
            });

            return !predictedProfRolesCopy.size;
        });

        return result;
    }, [professions, predictedProfRoles]);
};
